import {createClient} from 'contentful';

//Creates contentful client for read-only access and published content
export default function contentfulClient() {
  return createClient({
    space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID!,
    accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_DELIVERY_ACCESS_TOKEN!,
  }); 
}